<template>
    <curriculum-template />
</template>

<script>
    import CurriculumTemplate from "@/components/CurriculumTemplate.vue"
    export default {
        components: {
            CurriculumTemplate
        },
    }
</script>

<style lang="scss" scoped>

</style>